var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar__container"},[_c('div',{staticClass:"progress-bar__wrapper"},[_c('div',{staticClass:"progress-bar__progress",style:({ width: _vm.progressAmount + '%' })})]),_vm._v(" "),_c('span',{staticClass:"progress-bar__title"},[_vm._v(_vm._s(`${_vm.remainingAmount} ${_vm.translate('upsell.remaining')}`))])])
}
var staticRenderFns = []

export { render, staticRenderFns }